import { useEffect } from "react";
import { useConfigurationSelector } from "../../../redux/reducers/ConfigurationReducer/ConfigurationReducer";
import { getProductUrlByWS } from "../../../apis/AdminCenter/adminCenterApi";
import { useMsTeamsSelector } from "../../../redux/reducers/MicrosoftTeamsReducer/MicrosoftTeamsReducer";
import { translations } from "../../../translations";
import { useTranslate } from "../../../hook/useTranslate";
import { useLogic } from "../../Premium/UpgradePremium.logic";
import { appSourceBaseUrl } from "./UpgradeDialog";
import { useAppConfigurationSelector } from "../../../redux/reducers/AppConfigurationReducer/AppConfigurationReducer";
import { IframeManager } from "../../../utils/IframeManager";
import { configIframe } from "../../../const/configIframe";
import { setModalWithData, useModalSelector } from "../../../redux/reducers/ModalReducer/ModalReducer";
import { Modal } from "../../../interfaces/Modal";
import { useDispatch } from "react-redux";
export const useUpgradeLogic = (props) => {
    const upgradePremiumLogic = useLogic(props);
    const { locale, isOnMobile, userMail } = useMsTeamsSelector("locale", "isOnMobile", "userMail");
    const { data: config } = useConfigurationSelector("data");
    const { from } = useAppConfigurationSelector("from");
    const { data: modalData } = useModalSelector("data");
    const dispatch = useDispatch();
    const t = useTranslate(translations);
    // Opened on the request popup: consume the flag right away, or the next plain opening of the
    // dialog (openModal keeps the modal data) would jump to the popup too.
    useEffect(() => {
        if (!upgradePremiumLogic.state.loaded || !modalData?.openRequestAccess)
            return;
        upgradePremiumLogic.setState((prev) => ({ ...prev, showRequestAccessDialog: true }));
        dispatch(setModalWithData({ isOpen: Modal.UPGRADE, data: undefined }));
    }, [upgradePremiumLogic.state.loaded, modalData]);
    const showPaymentPage = () => {
        upgradePremiumLogic.setState((prev) => ({ ...prev, isPaymentOpen: true }));
        if (config.appSourceOfferId != undefined && config.appSourceOfferId.trim() != "") {
            upgradePremiumLogic.setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: false, isClosable: false, appSourceOpened: true }));
            setTimeout(() => {
                upgradePremiumLogic.setState((prev) => ({ ...prev, isClosable: true }));
                window.open(appSourceBaseUrl + locale + "/product/web-apps/" + config.appSourceOfferId, "_blank");
            }, 4000);
        }
        const dataFunction = (data) => {
            if (data.err && !data.result) {
                upgradePremiumLogic.setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: false }));
                props.appInsight?.trackEvent({
                    name: configIframe.Upgrade.trackingIds.cancel,
                });
            }
            else {
                upgradePremiumLogic.setLicencePlanId(data.result);
                upgradePremiumLogic.setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: true }));
                props.appInsight?.trackEvent({ name: configIframe.Upgrade.trackingIds.validate });
            }
        };
        IframeManager(configIframe.Upgrade, isOnMobile, props.appInsight, from, getProductUrlByWS(upgradePremiumLogic.user, upgradePremiumLogic.licencePlanId, userMail, config.adminCenterBaseUrl), getProductUrlByWS(upgradePremiumLogic.user, upgradePremiumLogic.licencePlanId, userMail, undefined, config.adminCenterBaseUrl), dataFunction);
    };
    return {
        closeDialog: upgradePremiumLogic.closeDialog,
        state: upgradePremiumLogic.state,
        showPaymentPageForSuperAdmin: upgradePremiumLogic.showPaymentPage,
        licencePlanId: upgradePremiumLogic.licencePlanId,
        setState: upgradePremiumLogic.setState,
        // The request itself (send, failure, close) is the shared Premium logic's: both dialogs ask the same way.
        sendAccessRequest: upgradePremiumLogic.sendAccessRequest,
        requestAccessFailed: upgradePremiumLogic.requestAccessFailed,
        closeRequestAccessDialog: upgradePremiumLogic.closeRequestAccessDialog,
        updateRequestAccessMessage: upgradePremiumLogic.updateRequestAccessMessage,
        // An admin taking a seat opens the licences page, as from the Premium dialog: showPaymentPage sends an
        // app with an AppSource offer (Calendar) to AppSource, which has nothing to assign.
        assignLicences: upgradePremiumLogic.assignLicences,
        showPaymentPage,
        user: upgradePremiumLogic.user
    };
};
